import React, { useState, useEffect } from 'react';

const OfficeBearers = () => {
  const [bearers, setBearers] = useState(null);

  useEffect(() => {
    setBearers([
      { name: "FAZLUR RAHMAN UMRI", designation: "President", image: "/images/president.png" },
      { name: "HAFIZ AZMATULLA UMRI", designation: "Vice President", image: "/images/vpresident.png" },
      { name: "HAFIZ KHALEELUR RAHMAN QURESHI UMRI", designation: "Vice President", image: "/images/v1president.png" },
      { name: "JANAB ABDUL KAREEM", designation: "Vice President", image: "/images/v2president.png" },
      { name: "HAFIZ ABDUL GAFFAR UMRI", designation: "General Secretary", image: "/images/gsecretary.png" },
      { name: "T USMAN GANI SANABILI", designation: "Joint Secretary", image: "/images/jsecretary.png" },
      { name: "K MOHAMMAD MOOSA JAMAI", designation: "Joint Secretary", image: "/images/j1secretary.png" },
      { name: "JANAB SHAIK SILAR", designation: "Joint Secretary", image: "/images/j2secretary.png" },
      { name: "JANAB FAROOQ KHAN", designation: "Treasurer", image: "/images/tresurer.png" },
    ]);
  }, []);

  if (!bearers) {
    return <div className="text-center py-20 text-lg sm:text-xl font-black">Loading...</div>;
  }

  const categories = {
    President: [],
    VicePresident: [],
    Secretary: [],
    JointSecretary: [],
    Treasurer: [],
    Member: [],
  };

  bearers.forEach(bearer => {
    const designation = normalizeDesignation(bearer.designation);
    if (categories[designation]) {
      categories[designation].push(bearer);
    } else {
      categories.Member.push(bearer);
    }
  });

  return (
    <div>
      {/* Hero Section */}
      <section className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px]">
        <img
          src="/images/mosque3.jpg"
          alt="Mosque"
          className="w-full h-full object-cover brightness-75"
        />
        <div className="absolute inset-0 bg-black opacity-35"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-8">
          <h1 className="text-white text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black mb-3 sm:mb-6 drop-shadow-lg uppercase leading-tight">
            Serving the Ummah with Excellence
          </h1>
          <p className="text-white max-w-2xl text-xs sm:text-sm md:text-base lg:text-xl drop-shadow-md font-light leading-relaxed px-2">
            United by a noble vision, our office bearers work wholeheartedly to guide and strengthen our organization. Their dedication, teamwork, and steadfast commitment are the pillars of our community service.
          </p>
        </div>
      </section>

      {/* Office Bearers Section */}
      <section className="py-10 sm:py-14 md:py-20 px-4 sm:px-6 md:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          {Object.keys(categories).map((category, index) => {
            if (categories[category].length > 0) {
              return (
                <Category key={index} title={category} members={categories[category]} />
              );
            }
            return null;
          })}
        </div>
      </section>
    </div>
  );
};

const titleLabels = {
  President: 'President',
  VicePresident: 'Vice President',
  Secretary: 'Secretary',
  JointSecretary: 'Joint Secretary',
  Treasurer: 'Treasurer',
  Member: 'Member',
};

const Category = ({ title, members }) => (
  <div className="mb-20 sm:mb-24 md:mb-28">
    <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-black mb-1 sm:mb-2 text-center pt-8 sm:pt-10 md:pt-12 font-black uppercase">
      Andhra Pradesh State
    </h3>
    <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-800 mb-10 sm:mb-14 md:mb-16 text-center font-black uppercase">
      {titleLabels[title] || title}
    </h3>

    <div className="flex flex-wrap justify-center gap-y-20 gap-x-6 sm:gap-x-10 md:gap-x-14 lg:gap-x-20 xl:gap-x-28">
      {members.map((member, idx) => (
        <MemberCard key={idx} member={member} />
      ))}
    </div>
  </div>
);

const MemberCard = ({ member }) => (
  <div className="relative bg-white rounded-lg shadow-md w-44 sm:w-52 md:w-60 lg:w-64 hover:shadow-xl transition border">
    <img
      src={member.image}
      alt={member.name}
      className="w-full h-56 sm:h-64 md:h-72 lg:h-80 object-cover rounded-lg"
    />
    {/* Floating name card */}
    <div className="absolute left-1/2 -translate-x-1/2 translate-y-1/2 bottom-0 bg-white text-black w-36 sm:w-40 md:w-44 px-2 sm:px-3 text-center py-2 sm:py-3 rounded-md shadow-md z-10">
      <h4 className="text-xs sm:text-sm font-black border-b-2 border-gray-200 mb-1 sm:mb-2 uppercase leading-tight pb-1 sm:pb-2">
        {member.name}
      </h4>
      <p className="text-xs text-black font-light">
        {member.designation}
      </p>
    </div>
  </div>
);

const normalizeDesignation = (designation) => {
  if (!designation) return 'Member';
  const normalized = designation.trim().toLowerCase();

  switch (normalized) {
    case 'president':
      return 'President';
    case 'vice president':
    case 'vice president (1)':
    case 'vice-president':
      return 'VicePresident';
    case 'secretary':
    case 'general secretary':
      return 'Secretary';
    case 'joint secretary':
      return 'JointSecretary';
    case 'treasurer':
      return 'Treasurer';
    default:
      return 'Member';
  }
};

export default OfficeBearers;

// backend working 24/03/26

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const OfficeBearers = () => {
//   const [bearers, setBearers] = useState(null);

//   useEffect(() => {
//     const fetchBearers = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/officebearers`);
//         setBearers(response.data);
//       } catch (error) {
//         console.error(error);
//         alert('Failed to fetch office bearers');
//       }
//     };

//     fetchBearers();
//   }, []);

//   if (!bearers) {
//     return <div className="text-center py-20 text-lg sm:text-xl font-black">Loading...</div>;
//   }

//   const categories = {
//     President: [],
//     VicePresident: [],
//     Secretary: [],
//     Treasurer: [],
//     Member: [],
//   };

//   bearers.forEach(bearer => {
//     const designation = normalizeDesignation(bearer.designation);

//     if (categories[designation]) {
//       categories[designation].push(bearer);
//     } else {
//       categories.Member.push(bearer);
//     }
//   });

//   return (
//     <div className='pb-[500px] sm:pb-[600px] md:pb-[320px] lg:pb-[420px]'>
//       {/* Hero Section */}
//       <section className="relative w-full h-[500px] sm:h-[600px] md:h-[700px]">
//         <img
//           src="/images/mosque3.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover brightness-75"
//         />
//         <div className="absolute inset-0 bg-black opacity-35"></div>
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-8">
//           <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black mb-4 sm:mb-6 drop-shadow-lg uppercase leading-tight">
//             Serving the Ummah<br className="sm:hidden"/> with Excellence
//           </h1>
//           <p className="text-white pt-4 sm:pt-6 md:pt-0 max-w-2xl text-sm sm:text-base md:text-lg lg:text-xl drop-shadow-md font-light leading-relaxed">
//             United by a noble vision, our office bearers work wholeheartedly to guide and strengthen our organization. Their dedication, teamwork, and steadfast commitment are the pillars of our community service.
//           </p>
//         </div>
//       </section>

//       {/* Office Bearers Section */}
//       <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-white">
//         <div className="max-w-7xl mx-auto">
//           {Object.keys(categories).map((category, index) => {
//             if (categories[category].length > 0) {
//               return (
//                 <Category key={index} title={category} members={categories[category]} />
//               );
//             }
//             return null;
//           })}
//         </div>
//       </section>
//     </div>
//   );
// };

// const Category = ({ title, members }) => (
//   <div className="mb-16 sm:mb-20">
//     <h3 className="text-2xl sm:text-3xl md:text-4xl text-black mb-2 text-center pt-8 sm:pt-10 md:pt-12 font-black uppercase">
//       Andhra Pradesh State
//     </h3>
//     <h3 className="text-2xl sm:text-3xl md:text-4xl text-gray-800 mb-6 sm:mb-8 text-center font-black uppercase">
//       {title}
//     </h3>
//     <div className="flex flex-wrap justify-center gap-8 sm:gap-12 md:gap-16 lg:gap-24 xl:gap-32">
//       {members.map((member, idx) => (
//         <div
//           key={idx}
//           className="relative bg-white rounded-lg shadow-md overflow-visible w-56 sm:w-60 md:w-64 hover:shadow-xl transition border"
//         >
//           <img
//             src={member.image}
//             alt={member.name}
//             className="w-full h-72 sm:h-76 md:h-80 object-cover"
//           />
//           <div className="absolute left-1/2 transform -translate-x-1/2 translate-y-1/2 bottom-0 bg-white text-black w-40 sm:w-44 px-3 sm:px-4 text-center py-2.5 sm:py-3 rounded-md shadow-md z-10">
//             <h4 className="text-sm sm:text-md font-black border-b-2 border-gray-200 mb-2 uppercase">
//               {member.name}
//             </h4>
//             <p className="text-xs sm:text-sm text-black font-light">
//               {member.designation}
//             </p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// const normalizeDesignation = (designation) => {
//   if (!designation) return 'Member';
//   const normalized = designation.trim().toLowerCase();
  
//   switch (normalized) {
//     case 'president':
//       return 'President';
//     case 'vice president':
//     case 'vice president (1)':
//     case 'vice-president':
//       return 'VicePresident';
//     case 'secretary':
//     case 'general secretary':
//       return 'Secretary';
//     case 'treasurer':
//       return 'Treasurer';
//     default:
//       return 'Member';
//   }
// };

// export default OfficeBearers;





// old design


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const OfficeBearers = () => {
//   const [bearers, setBearers] = useState(null);

//   useEffect(() => {
//     const fetchBearers = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/officebearers`);
//         // console.log('Fetched Bearers:', response.data);
//         setBearers(response.data);
//       } catch (error) {
//         console.error(error);
//         alert('Failed to fetch office bearers');
//       }
//     };

//     fetchBearers();
//   }, []);

//   if (!bearers) {
//     return <div className="text-center py-20">Loading...</div>;
//   }

//   // Categorize bearers by designation, handling plural and singular designations
//   const categories = {
//     President: [],
//     VicePresident: [],
//     Secretary: [],
//     Treasurer: [],
//     Member: [],
//   };

//   bearers.forEach(bearer => {
//     const designation = normalizeDesignation(bearer.designation);

//     // Assign the bearer to the correct category based on the normalized designation
//     if (categories[designation]) {
//       categories[designation].push(bearer);
//     } else {
//       // If designation doesn't match a predefined category, push it to "Member"
//       categories.Member.push(bearer);
//     }
//   });

//   return (
//     <div className='pb-[600px] md:pb-[320px] lg:pb-[420px]'>
//       {/* Hero Section */}
//       <section className="relative w-full h-[700px]">
//         <img
//           src="/images/mosque3.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover brightness-75"
//         />
//         <div className="absolute inset-0 bg-black opacity-35"></div>
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
//           <h1 className="text-white text-4xl md:text-6xl font-bold mb-4 drop-shadow-lg">
//             Serving the Ummah with Excellence
//           </h1>
//           <p className="text-white pt-6 md:pt-0 max-w-2xl text-lg md:text-xl drop-shadow-md">
//             United by a noble vision, our office bearers work wholeheartedly to guide and strengthen our organization. Their dedication, teamwork, and steadfast commitment are the pillars of our community service.
//           </p>
//         </div>
//       </section>

//       {/* Office Bearers Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           {/* <h2 className="text-5xl font-semibold text-center text-gray-800 mb-12">Office Bearers</h2> */}

//           {/* Dynamically render categories */}
//           {Object.keys(categories).map((category, index) => {
//             if (categories[category].length > 0) {
//               return (
//                 <Category key={index} title={category} members={categories[category]} />
//               );
//             }
//             return null; // If there are no members in a category, skip rendering
//           })}
//         </div>
//       </section>
//     </div>
//   );
// };

// const Category = ({ title, members }) => (
//   <div className="mb-20">
//     <h3 className="text-4xl text-black mb-2 text-center  pt-12">Andhra Pradesh State</h3>
//     <h3 className="text-4xl text-gray-800 mb-8 text-center">{title}</h3>
//     <div className="flex flex-wrap justify-center gap-32 ">
//       {members.map((member, idx) => (
//         <div
//           key={idx}
//           className="relative bg-white rounded-lg shadow-md overflow-visible w-64 hover:shadow-xl transition border"
//         >
//           <img
//             src={member.image}
//             alt={member.name}
//             className="w-full h-80 object-cover"
//           />
//           <div className="absolute left-1/2 transform -translate-x-1/2 translate-y-1/2 bottom-0 bg-white text-black w-44 px-4 text-center py-3 rounded-md shadow-md z-10">
//             <h4 className="text-md font-semibold border-b-2 border-gray-200 mb-2">{member.name}</h4>
//             <p className="text-sm text-black">{member.designation}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// // Normalize designation by capitalizing the first letter and removing extra spaces
// const normalizeDesignation = (designation) => {
//   if (!designation) return 'Member';
//   const normalized = designation.trim().toLowerCase();
  
//   // Match specific designations
//   switch (normalized) {
//     case 'president':
//       return 'President';
//     case 'vice president':
//     case 'vice president (1)':
//     case 'vice-president':
//       return 'VicePresident';
//     case 'secretary':
//     case 'general secretary':
//       return 'Secretary';
//     case 'treasurer':
//       return 'Treasurer';
//     default:
//       return 'Member'; // Assign all unrecognized designations as "Member"
//   }
// };

// export default OfficeBearers;


